import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NgbModule, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService } from '../../Services/ConfigService';
import { ChecklistTaskEditComponent } from '../Checklist/ChecklistTaskComponentEdit';
import { PersonRoleEnum } from '../../Models/OtherClasses';
import { BaseBusyableComponent } from '../../Services/BaseBusyableComponent';
import { CompanyService } from '../../Services/Custom/ServiceCompany';
import { MenuFavoriteService } from '../../Services/Custom/ServiceMenuFavorite';
import { DialogService } from '../../Services/DialogService';
import { TrialPopUpComponent } from './trialPopUpComponent';

@Component({
	selector: 'app-menu',
	templateUrl: 'AppMenu.html',
	moduleId: module.id
})
export class MenuComponent extends BaseBusyableComponent implements OnInit {

	ngOnInit(): void {
		this.myCompanyService.get(this.configData.AppConfig.company)
			.subscribe(comp => {
				this.subscriptionName = comp.TypeSubscriptionName;
			});
		if (this.configData.AppConfig.isOnTrial) {
			this.route.queryParams.subscribe(params => {
				var val = params['tp'];
				if (val) {
					var expire = this.configData.AppConfig.trialExpiration;
					
					if (expire) {
						this.configData.AppConfig.trialExpiration = '';
						this.modal = this.modalService.open(TrialPopUpComponent, { size: 'sm' });
						this.modal.componentInstance.expire = expire;
						this.modal.componentInstance.first = params['firstpop'];
						this.modal.result.then(() => {
						});
					}
				}
			})
			
		}
	}

	modal: NgbModalRef = null;

	constructor(
		private myCompanyService: CompanyService,
		private myMenuFavoriteService: MenuFavoriteService,
		public configData: ConfigService,
		public modalService: NgbModal,
		public router: Router,
		public route: ActivatedRoute) {
		super();
		this.isSuperAdmin = this.configData.isSuperAdmin;
	}

	enabled: boolean = false;
	isDentalProgram: boolean = this.configData.isDentalProgram;
	isSignUpCompany = this.configData.isSignUpCompany;
	isIntro: boolean = this.configData.isIntroVersion;
	isMaster: boolean = this.configData.isMasterCompany;
	isLMS: boolean = this.configData.isLMSCompany && !this.isMaster;
	isHR: boolean = this.configData.isHRCompany && !this.isMaster;
	isTracker: boolean = this.configData.isTrackerCompany && !this.isMaster && this.configData.IsUserInRole(PersonRoleEnum.ADMIN) && !this.isIntro; 
	isAdmin: boolean = this.configData.IsUserInRole(PersonRoleEnum.ADMIN);
	isCollapsed = true;
	isNavbarCollapsed: boolean = false;
	isSubCollapsed = true;
	isSuperAdmin: boolean = false;
	subscriptionName: string = '';
	_hrtoolbox: boolean = false;
	get hrtoolbox(): boolean {
		return this._hrtoolbox;
	}
	set hrtoolbox(val: boolean) {
		this._hrtoolbox = val;
		if (!val) {
			this.tasks =
				this.checklists =
				this.onboardingchecklists =
				this.commendation =
				this.organization =
				this.documents =
				this.performanceReviews =
				this.leaveRequests = false;
		}
	}
	
	tasks: boolean = false;
	checklists: boolean = false;
	onboardingchecklists: boolean = false;
	commendation: boolean = false;
	organization: boolean = false;
	documents: boolean = false;
	performanceReviews: boolean = false;
	leaveRequests: boolean = false;

	hasFavorite(item: string): boolean {
		var idx = this.configData.AppConfig.FavoritePages.indexOf(item);
		return idx >= 0;
	}
	addFavorite(item: string) {
		if (!this.hasFavorite(item)) {
			this.myMenuFavoriteService.save(item)
				.subscribe(obj => {
					this.configData.AppConfig.FavoritePages.push(item);
				});
		}
	}
	removeFavorite(item: string) {
		var idx = this.configData.AppConfig.FavoritePages.indexOf(item);
		if (idx >= 0) {
			this.myMenuFavoriteService.deleteItem(item)
				.subscribe(obj => {
					this.configData.AppConfig.FavoritePages.splice(idx, 1);
				});
		}
	}

	//   toggleMenu() {
	//	this.isCollapsed = !this.isCollapsed;
	//}

	//   toggleSubMenu() {
	//	this.isSubCollapsed = !this.isSubCollapsed;
	//}

	openMenu() {
		//this.trigger.openMenu();
	}

	editTask() {
		var modal: NgbModalRef = this.modalService.open(ChecklistTaskEditComponent, { size: 'lg' });

		modal.result.then((result: ePM.Logic.ChecklistTask) => {
			if (result) { }
		}, (reason) => {

		});
	}


	pickCompany(comp: ePM.Logic.Company) {
		if (comp) {
			this.router.navigateByUrl('/ang/Company/' + comp.CompanyID);
		}
	}
}